import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./index.css";

const Layout = styled.div`
  margin: 0 auto;
  max-width: 960px;
  padding: 0 1.0875rem 1.45rem;
  padding-top: 0;
`;

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Adam & Casey's Wedding"
      meta={[
        { name: "description", content: "Adam and Casey's Wedding" },
        { name: "keywords", content: "wedding" }
      ]}
    />
    <Header />
    <Layout>{children()}</Layout>
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js